export * from './client_hacks';

export const DEMO_AGENCY_UID = '2384';
export const DEMO_ACCT_UIDS = ['3564', '3480', '1091', '1683', '1608', '2160', '2385'];

export const DEV_TEST_UIDS = ['1048'];
export * from './telnyxSettings';

export * from './pixel';
